const { log } = console;
export default log;
